"use client";

import * as React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
const pledgePillars = [{
  id: "east-asia-hub",
  title: "East Asia",
  iconName: "ship",
  summary: "Regional sourcing and logistics coordination across Hong Kong, Taiwan, South Korea, and surrounding East Asian markets.",
  detailParagraph1: "Oriental World Corporation Limited maintains a robust presence in major East Asian ports, facilitating the seamless movement of industrial bovine tallow and used cooking oil. Our Hong Kong headquarters serves as the central nervous system for these regional operations.",
  detailParagraph2: "We specialize in bulk vessel coordination and multi-modal transport solutions that connect inland production facilities with international maritime routes, ensuring consistent supply for our industrial partners in the energy sector."
}, {
  id: "southeast-asia-hub",
  title: "Southeast Asia",
  iconName: "route",
  summary: "Regional maritime logistics and sourcing coordination across Southeast Asia.",
  detailParagraph1: "Our Southeast Asian network focuses on the efficient sourcing and transport of sustainable biofuel feedstocks. We manage complex logistics across diverse maritime territories, adhering to strict ISCC compliance standards for every shipment.",
  detailParagraph2: "By leveraging local port infrastructure and regional trade agreements, we provide our clients with competitive lead times and reliable quality control. Our operations include specialized storage solutions and rigorous inspection protocols at every transit point."
}, {
  id: "mongolia-central-hub",
  title: "Northern Trade Corridors",
  iconName: "train",
  summary: "Cross-border rail and inland logistics coordination supporting regional commodity trade routes.",
  detailParagraph1: "The northern corridor presents unique logistical challenges that Oriental World Corporation is uniquely equipped to handle. We manage extensive cross-border rail operations that bridge the gap between landlocked production zones and coastal export terminals.",
  detailParagraph2: "Our expertise in northern trade routes ensures that industrial animal fats and feedstocks are transported under optimal conditions. We coordinate directly with regional rail authorities to streamline customs clearance and minimize transit delays for our global customers."
}];
function getIcon(name: string) {
  const commonProps = {
    viewBox: "0 0 24 24",
    strokeWidth: "1.5",
    fill: "none",
    stroke: "currentColor",
    className: "size-8 text-primary"
  };
  switch (name) {
    case "ship":
      return <svg {...commonProps}><path d="M2 21h20" /><path d="M3.5 21 2 16h20l-1.5 5" /><path d="M5 16V7l3-2v11" /><path d="M13 16V3l3-2v15" /></svg>;
    case "route":
      return <svg {...commonProps}><circle cx="6" cy="19" r="3" /><path d="M9 19h8.5a3.5 3.5 0 0 0 0-7h-11a3.5 3.5 0 0 1 0-7H15" /><circle cx="18" cy="5" r="3" /></svg>;
    case "train":
      return <svg {...commonProps}><rect width="16" height="16" x="4" y="3" rx="2" /><path d="M4 11h16" /><path d="M12 3v8" /><path d="m8 19-2 3" /><path d="m18 22-2-3" /><path d="M8 15h.01" /><path d="M16 15h.01" /></svg>;
    case "leaf":
      return <svg {...commonProps}><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" /><circle cx="12" cy="10" r="3" /></svg>;
    case "tree":
      return <svg {...commonProps}><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10" /><path d="m9 12 2 2 4-4" /></svg>;
    case "users":
      return <svg {...commonProps}><path d="M3 10h18" /><path d="M3 14h18" /><path d="M5 6v12" /><path d="M9 6v12" /><path d="M15 6v12" /><path d="M19 6v12" /></svg>;
    default:
      return <svg {...commonProps}><path d="M9 20 3 17V4l6 3 6-3 6 3v13l-6-3-6 3Z" /><path d="M9 7v13" /><path d="M15 4v13" /></svg>;
  }
}
export default function OurStewardshipPledge() {
  return;
}